import { IMutationQuery, IQuery, IUserConfig, IAccountDetail } from '@/types';
import { decodeAuthToken, ssoAxiosInstance } from '@/utils';

export const authenticateMeQuery = (): IQuery<IUserConfig | null> => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};
  return {
    queryKey: ['persist', 'me', organisationId, memberId],
    queryFn: async () => {
      if (!organisationId || !memberId) {
        return null;
      }
      const meDetails = await ssoAxiosInstance.get<IUserConfig>(
        `/authentication/me`
      );
      return meDetails.data;
    },
  };
};

export const accountDetailsQuery = (): IQuery<IAccountDetail[] | null> => {
  const { organisationId, memberId, source } = decodeAuthToken() ?? {};
  return {
    queryKey: ['persist', 'account', organisationId, memberId],
    queryFn: async () => {
      if (!organisationId || !memberId || source === 'IAM') {
        return null;
      }
      const accountDetails = await ssoAxiosInstance.get<IAccountDetail[]>(
        `authentication/account`
      );
      const accountDetailsWithoutIAM =
        accountDetails?.data?.filter((account) => {
          return account?.loginType !== 'IAM';
        }) ?? [];
      return accountDetailsWithoutIAM;
    },
  };
};

export const logoutFromAllDevicesQuery = (): IMutationQuery<void> => {
  return {
    mutationKey: ['logout-all-devices'],
    mutationFn: async () => {
      await ssoAxiosInstance.get<void>('/authentication/session/logout');
    },
  };
};
